import { createFileRoute } from "@tanstack/react-router";

import { RequireCapability } from "@components/RequireCapability.tsx";
import { MACHINE_READ } from "@/AccessPermissions.ts";
import { Overview } from "@/features/overview/components/Overview.tsx";

export const Route = createFileRoute("/")({
  validateSearch: (search: Record<string, unknown>): { q?: string } => {
    // The router reads ?q=10000521 as a number, so turn numbers back into text.
    const q = typeof search.q === "number" ? String(search.q) : search.q;
    return { q: typeof q === "string" && q !== "" ? q : undefined };
  },
  component: () => (
    <RequireCapability all={[MACHINE_READ]}>
      <Overview />
    </RequireCapability>
  ),
  staticData: { breadcrumb: "menu.overview" }
});
